import { QUERY_PARAM_PRINT_FEATURE_FLAGS } from '@canvas/constants/query-params';

import {
  currentFeatureFlagState,
  featureFlagsInitialized,
} from './client-feature-flags.ts';
import { getAllExperimentValues } from './experiments.ts';

/**
 * Prints all feature flags and experiment values to the console
 */
export const printFeatureFlagsAndExperiments = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has(QUERY_PARAM_PRINT_FEATURE_FLAGS)) {
    return;
  }

  await featureFlagsInitialized;

  const featureFlags = currentFeatureFlagState;
  const experimentValues = getAllExperimentValues();

  const sortedFeatureFlags = Object.entries(featureFlags)
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
    .reduce(
      (obj, [key, value]) => {
        obj[key] = value;
        return obj;
      },
      {} as Record<string, any>,
    );

  const sortedExperimentValues = Object.entries(experimentValues)
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
    .reduce(
      (obj, [key, value]) => {
        obj[key] = value;
        return obj;
      },
      {} as Record<string, any>,
    );

  console.log('--- Feature Flags ---');
  console.log(JSON.stringify(sortedFeatureFlags, null, 2));

  console.log('--- Experiment Values ---');
  console.log(JSON.stringify(sortedExperimentValues, null, 2));
};
